import {FilterOperators, getAllFilterOperators} from '@github-ui/filter-core'
import {FilterOperator, type MutableFilterBlock} from '@github-ui/filter-core'
import {TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Button} from '@primer/react'

import styles from './OperatorSelect.module.css'

interface OperatorSelectProps {
  filterBlock: MutableFilterBlock
  index: number
  setFilterOperator: (operator: FilterOperator) => void
}

export const OperatorSelect = ({filterBlock, index, setFilterOperator}: OperatorSelectProps) => {
  const title = filterBlock.operator ? FilterOperators[filterBlock.operator] : FilterOperators[FilterOperator.Is]
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <Button
          size="small"
          disabled={!filterBlock.provider}
          id={`afd-row-${index}-operator`}
          aria-label={`${title && title.trim() ? `${title.trim()}, ` : ''}Operator ${index + 1}`}
          className={styles.Button_0}
          block
          alignContent="start"
          trailingAction={() => <TriangleDownIcon className={styles.Octicon_0} />}
        >
          {title}
        </Button>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay width="auto">
        <ActionList selectionVariant="single">
          {getAllFilterOperators(filterBlock.provider).map(operator => (
            <ActionList.Item
              key={`advanced-filter-item-${filterBlock.id}-operator-${operator}`}
              onSelect={() => setFilterOperator(operator)}
              selected={operator === filterBlock.operator}
            >
              {FilterOperators[operator]}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
